import React from "react";

const MessageCircle = ({ onClick }: { onClick?: () => void }) => (
  <svg cursor={"pointer"} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.875 8.14585C14.8774 9.08076 14.659 10.003 14.2375 10.8375C13.7377 11.8375 12.9694 12.6786 12.0186 13.2666C11.0678 13.8546 9.97209 14.1663 8.85417 14.1667C7.91926 14.1691 6.997 13.9507 6.1625 13.5292L2.125 14.875L3.47083 10.8375C3.04933 10.003 2.8309 9.08076 2.83333 8.14585C2.83377 7.02793 3.14543 5.93221 3.73343 4.98141C4.32142 4.03061 5.16251 3.2623 6.1625 2.76252C6.997 2.34101 7.91926 2.12258 8.85417 2.12502H9.20833C10.6847 2.20647 12.0792 2.82964 13.1248 3.87521C14.1704 4.92078 14.7935 6.31527 14.875 7.79169V8.14585Z"
      stroke="#272727"
      strokeWidth="1.20417"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default React.memo(MessageCircle);
